export const EntityTypeKeys = {
  Group: 'Group',
  User: 'User',
};
